import type { Theme } from "@mui/material";

const MuiListItem = (theme: Theme) => {
  const primaryWithOpacity = theme.palette.primary as typeof theme.palette.primary & {
    "4p": string;
    "12p": string;
  };

  return {
    button: {
      "&:hover": {
        backgroundColor: primaryWithOpacity["4p"],
      },
      "&:focus": {
        backgroundColor: primaryWithOpacity["12p"],
      },
    },
  };
};

export default MuiListItem;
